var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStatistics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4998 8.72489C17.5063 8.838 17.4673 8.94899 17.3915 9.03323C17.3108 9.11732 17.1997 9.16538 17.0832 9.16656H10.8332V2.93323C10.8344 2.8167 10.8824 2.70556 10.9665 2.62489C11.0475 2.54222 11.1592 2.49694 11.2748 2.49989C14.6197 2.71503 17.2847 5.38008 17.4998 8.72489ZM15.3998 10.8332H9.16651V4.59989C9.1666 4.48644 9.12042 4.37785 9.03864 4.29921C8.95686 4.22057 8.84654 4.17869 8.73318 4.18323C5.17042 4.41382 2.42173 7.41021 2.49865 10.9796C2.57556 14.549 5.45076 17.4242 9.02015 17.5011C12.5895 17.578 15.5859 14.8293 15.8165 11.2666C15.821 11.1532 15.7792 11.0429 15.7005 10.9611C15.6219 10.8793 15.5133 10.8331 15.3998 10.8332Z",
    fill: "#000000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStatistics);
export default __webpack_public_path__ + "static/media/icon-statistics.f880073f.svg";
export { ForwardRef as ReactComponent };